import * as React from 'react';

import {Button} from 'shells/button/button';
import {Body} from 'shells/typography/body';

type Props = {
    setIsPreparingToSend: () => void;
    canSend: boolean;
};

export function ToFieldNewAudienceManagement(props: Props) {
    return (
        <div className='mb-24 font-size-small'>
            <Body>To</Body>
            <div className='mt-8'>
                <Body isItalic={true} size='small'>
                    You’ll choose your recipients when you{' '}
                    {props.canSend ? (
                        <Button
                            variant='text-primary'
                            size='normal'
                            noPadding={true}
                            onClick={() => props.setIsPreparingToSend()}
                        >
                            prepare to send.
                        </Button>
                    ) : (
                        'prepare to send.'
                    )}
                </Body>
            </div>
        </div>
    );
}
